import React from 'react';
import './App.css';
import { styles } from './generalStyles';
import ConnectWallet from './ConnectWallet';
// @ts-ignore
import { Transition } from 'react-transition-group';

import { isMobile } from 'react-device-detect';

import coin from './assets/bouleClear.png';
import bouleLogo from './assets/boule-logo.png';
import bouleSmall from './assets/boule-small.png';
import zeus from './assets/1-2.jpeg';
import andrew from './assets/2-2.jpeg';
import chris from './assets/3-3.jpeg';
import issah from './assets/4-3.jpeg';

import twitter from './assets/twitter.png';
import discord from './assets/discord.png';
import reddit from './assets/reddit.png';
import ModalComponent from './ModalComponent';
import { CONTRACT_ADDRESS } from './constants';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCJk9yMc8mjeDE9_i-6nwdPQINIqWCQ3C8",
  authDomain: "billion-dollar-mint.firebaseapp.com",
  projectId: "billion-dollar-mint",
  storageBucket: "billion-dollar-mint.appspot.com",
  messagingSenderId: "931158134590",
  appId: "1:931158134590:web:1cb9ffc0b368af3dcee66f",
  measurementId: "G-SLQQQ3RJHR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

type Props = {};
type State = {
    scale: number,
    opacity: number,
    showScreen: boolean,
    showConnect: boolean,
    showCoins: boolean,
    innerHeight: number,
    connected: boolean,
    emailOnList: string,
    potentialEmail: string,
    networkId: number,
};

const emailRegex = /^\S+@\S+\.\S+$/;

class App extends React.Component<Props, State> {

    firstDiv: React.RefObject<HTMLDivElement>;
    howToBuy: React.RefObject<HTMLDivElement>;
    team: React.RefObject<HTMLDivElement>;

    connectWallet: ConnectWallet | null;

    constructor(props: Props) {
        super(props);
        this.state = {
            scale: 1,
            opacity: 0,
            showScreen: false,
            showConnect: false,
            showCoins: isMobile,
            innerHeight: window.innerHeight,
            connected: false,
            emailOnList: '',
            potentialEmail: '',
            networkId: 1,
        };

        this.firstDiv = React.createRef();
        this.howToBuy = React.createRef();
        this.team = React.createRef();

        this.connectWallet = null;

    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ showScreen: true });
        }, 500);

        setTimeout(() => {
            this.setState({ showConnect: true });
        }, 800);

        // if (isMobile) return;
        window.addEventListener('scroll', () => {
            let scale = 1 - (window.scrollY * 2) / this.state.innerHeight;
            if (scale !== this.state.scale) {
                this.setState({ scale });
            }
        }, { passive: true });
    }

    render() {

        const lightBorder = (ref?: any) => <div ref={ref} style={{ width: '100%', height: .5, backgroundColor: '#aaaaaa', marginTop: 50, marginBottom: 50 }} />;
        const lightBorderLessPadding = () => <div style={{ width: '100%', height: .5, backgroundColor: '#aaaaaa', marginTop: 20, marginBottom: 20 }} />;
        const lightBorderNoPaddingOnTop = () => <div style={{ width: '100%', height: .5, backgroundColor: '#aaaaaa', marginBottom: 50 }} />;

        const { showConnect, showScreen, scale, innerHeight, connected, emailOnList, potentialEmail } = this.state;


        const duration = 300;

        const defaultStyle = {
            transition: `all ${duration}ms ease-in-out`,
            opacity: 0,
        }

        const transitionStyles: { [key: string]: any } = {
            entering: { opacity: 1 },
            entered: { opacity: 1 },
            exiting: { opacity: 0 },
            exited: { opacity: 0 },
        };

        const connectTransitionStyles: { [key: string]: any } = {
            entering: { opacity: 1, marginTop: 0 },
            entered: { opacity: 1, marginTop: 0 },
            exiting: { opacity: 0, marginTop: 100 },
            exited: { opacity: 0, marginTop: 100 },
        };


        return (
            <Transition in={showScreen} timeout={0}>
                {(state: any) =>
                    <div style={{
                        ...defaultStyle,
                        ...transitionStyles[state],
                    }}>
                        <ModalComponent showModal={Boolean(emailOnList)} onRequestClose={() => this.setState({ emailOnList: '' })}>
                            <div style={{ ...styles.marginBottomExtra, ...styles.header3, ...styles.marginBottom }}><b>{'ADDED TO EMAIL LIST'}</b></div>
                            {lightBorderNoPaddingOnTop()}
                            <p >You will receive team emails, project updates, and exclusive offers at <b>{emailOnList}.</b> Cheers!</p>
                            <div
                                className='clickable'
                                onClick={() => {
                                    this.setState({ emailOnList: '' });
                                }}
                                style={{ ...styles.marginBottom, ...styles.roundedCorners, ...styles.baseButton, ...styles.enabledButton, ...{ cursor: 'pointer', justifyContent: 'center', display: 'flex' } }}
                            >
                                <p style={{ ...styles.text, ...styles.inverseText, ...styles.bold, ...{ textAlign: 'center', margin: 0, display: 'flex', alignItems: 'center' } }}>{'Done'}</p>
                            </div>
                        </ModalComponent>
                        {(connected || scale > .5) ? null : (isMobile ?
                            <div style={{ width: '100%', padding: 5, opacity: 1 - scale, maxHeight: 30, display: 'flex', justifyContent: 'center', ...styles.defaultBackgroundColor, position: 'fixed', zIndex: 2, borderBottom: '1px solid #dddddd' }}>
                                <div
                                    className='clickable'
                                    onClick={() => this.connectWallet?.handleConnectWallet()}
                                    style={{ ...styles.roundedCorners, ...styles.enabledButton, ...{ cursor: 'pointer', justifyContent: 'center', display: 'flex', width: 200, padding: 0, height: 20 } }}
                                >
                                    <p style={{ ...styles.text, fontSize: 12, ...styles.inverseText, ...styles.bold, ...{ textAlign: 'center', margin: 0, display: 'flex', alignItems: 'center', padding: 0 } }}>{'Connect Wallet'}</p>
                                </div>
                            </div> :
                            <div style={{ width: '100%', padding: 5, opacity: 1 - scale, maxHeight: 30, display: 'flex', justifyContent: 'center', ...styles.defaultBackgroundColor, position: 'fixed', zIndex: 2, borderBottom: '1px solid #dddddd' }}>
                                <div
                                    className='clickable'
                                    onClick={() => this.connectWallet?.handleConnectWallet()}
                                    style={{ ...styles.roundedCorners, ...styles.baseButton, ...styles.enabledButton, ...{ cursor: 'pointer', justifyContent: 'center', display: 'flex', width: 200, height: 25 } }}
                                >
                                    <p style={{ ...styles.text, ...styles.inverseText, ...styles.bold, ...{ textAlign: 'center', margin: 0, display: 'flex', alignItems: 'center' } }}>{'Connect Wallet'}</p>
                                </div>
                            </div>)}
                        <div style={{ maxWidth: 1000, margin: 'auto' }}>
                            <div style={{ height: innerHeight, opacity: isMobile ? 1 : scale, display: 'flex', flexDirection: 'column', zIndex: 2, justifyContent: 'space-between' }}>
                                {<div><div style={{ display: 'flex', ...styles.flexRow, justifyContent: 'space-between', height: 50, alignItems: 'flex-end' }}>
                                    <img alt={'topLogo'} src={bouleLogo} style={{ height: 40, cursor: 'pointer', ...(isMobile && { marginLeft: 10 }) }}></img>
                                    <div style={{ display: 'flex', ...styles.flexRow, justifyContent: 'flex-end', height: 30, alignItems: 'center' }}>
                                        {!isMobile && <><p onClick={() => window.scroll({ top: this.howToBuy?.current?.getBoundingClientRect().top, behavior: 'smooth' })} style={{ ...styles.inverseText, ...styles.marginRightExtra, fontSize: 12, fontStyle: 'italic', cursor: 'pointer' }}>How to Buy</p>
                                            <p onClick={() => window.scroll({ top: this.team?.current?.getBoundingClientRect().top, behavior: 'smooth' })} style={{ ...styles.inverseText, ...styles.marginRightExtra, fontSize: 12, fontStyle: 'italic', cursor: 'pointer' }}>The Team</p>
                                            <a href={'https://www.dropbox.com/s/rjkp7em8hp6uvwz/Lazy-mint%20Reward%20System.pdf?dl=0'} target={'_blank'} rel="noreferrer"><p style={{ ...styles.inverseText, marginRight: 30, fontSize: 12, fontStyle: 'italic', textDecoration: 'none' }}>Whitepaper</p></a></>}
                                        <a href={'https://discord.com/invite/URcJDsamcv'} target={'_blank'} rel="noreferrer"><img alt='discord' style={{ height: 25, ...styles.marginRightExtra, marginTop: 0 }} src={discord} /></a>
                                        <a href={'https://www.reddit.com/user/BouleNFT'} target={'_blank'} rel="noreferrer"><img alt='reddit' style={{ height: 25, filter: 'invert(1)', ...styles.marginRightExtra, marginTop: 0 }} src={reddit} /></a>
                                        <a href={'https://twitter.com/BouleNft'} target={'_blank'} rel="noreferrer"><img alt='twitter' style={{ height: 25, filter: 'invert(1)', marginTop: 0, marginRight: isMobile ? 20 : 8 }} src={twitter} /></a>
                                    </div>
                                </div>
                                    <div style={{ width: '100%', height: .5, backgroundColor: '#aaaaaa', marginTop: 10, marginBottom: 10 }} />
                                </div>}
                                <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: isMobile ? 'flex-start' : 'space-between', alignItems: 'center', margin: isMobile ? '' : 'auto', ...styles.paddingExtra, paddingBottom: 0, paddingTop: 0 }}>
                                    {<img alt='coin' style={{ marginLeft: isMobile ? 0 : 0, height: isMobile ? '20vw' : 220, padding: isMobile ? 0 : 60 }} src={isMobile ? bouleSmall : coin}></img>}
                                    <Transition in={showConnect} timeout={1300}>
                                        {(state: any) =>
                                            <div style={{
                                                ...defaultStyle,
                                                ...connectTransitionStyles[state],
                                                paddingRight: isMobile ? 0 : 50
                                            }}>
                                                {isMobile && <p style={{ ...styles.centerText, ...styles.fullWidth, ...styles.inverseText, maxWidth: '100vw', marginBottom: 25, marginTop: 0 }}>Win the pot and a rare NFT! Connect your wallet and mint the winning token.</p>}
                                                <div style={{
                                                    width: 300,
                                                    margin: 'auto',
                                                    position: 'relative',
                                                    ...styles.shadow,
                                                    ...styles.centerAligned,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    ...styles.defaultBackgroundColor,
                                                    ...styles.roundedCorners,
                                                    overflow: 'hidden'
                                                }}>
                                                    <ConnectWallet
                                                        setConnected={(connected) => this.setState({ connected })}
                                                        ref={(wall) => this.connectWallet = wall}
                                                    />
                                                </div>
                                            </div>
                                        }</Transition>
                                </div>
                                <div style={{ justifySelf: 'flex-end', paddingBottom: 20, marginRight: 20, marginLeft: 20, overflow: 'hidden' }}>
                                    {!isMobile && <p style={{ ...styles.centerText, ...styles.fullWidth, ...styles.inverseText, maxWidth: '100vw', marginBottom: 20 }}>Win the pot and a rare NFT! Connect your wallet and mint the winning token.</p>}
                                    {!isMobile && <div
                                        className='clickable'
                                        onClick={() => window.scroll({ top: this.firstDiv?.current?.getBoundingClientRect().top, behavior: 'smooth' })}
                                        style={{ ...styles.marginBottom, ...styles.roundedCorners, ...styles.shadow, ...styles.baseButton, ...styles.defaultBackgroundColor, ...{ cursor: 'pointer', justifyContent: 'center', display: 'flex', width: 200, margin: 'auto' } }}
                                    >
                                        <p style={{ ...styles.text, ...styles.bold, ...{ textAlign: 'center', margin: 0, display: 'flex', alignItems: 'center' } }}>{'Learn More Below'}</p>
                                    </div>}
                                </div>
                            </div>
                            <div ref={this.firstDiv} style={{ padding: 20 }}>
                                <p style={{ ...styles.inverseText, ...styles.bold, fontStyle: 'italic', ...styles.landingPage, ...styles.marginBottomSmall, paddingTop: 10 }}>WELCOME TO THE MODERN BOULÉ</p>
                                <p style={{ ...styles.inverseText, ...styles.justify, ...(!isMobile && { marginTop: 20 }) }}>The goal is to mint 1 million tokens!  One Greek will inherit all of the net proceeds raised through Boulé. The net proceeds are calculated using the below costs estimates:</p>
                                <div style={{ ...styles.shadow, ...styles.padding, ...styles.roundedCorners, backgroundColor: '#675FC8' }}>
                                    <div style={{ ...styles.flexRow, display: 'flex', justifyContent: 'space-between' }}>
                                        <p style={{ ...styles.inverseText }}>MATIC Raised</p>
                                        <p style={{ ...styles.bold, ...styles.inverseText }}>1,000,000.00</p>
                                    </div>
                                    <div style={{ ...styles.flexRow, display: 'flex', justifyContent: 'space-between' }}>
                                        <p style={{ ...styles.inverseText }}>Paying Mom's Rent</p>
                                        <p style={{ ...styles.bold, ...styles.dullText }}>(100,000.00)</p>
                                    </div>
                                    <div style={{ ...styles.flexRow, display: 'flex', justifyContent: 'space-between' }}>
                                        <p style={{ ...styles.inverseText }}>Marketings Costs</p>
                                        <p style={{ ...styles.bold, ...styles.dullText }}>(76,602.00)</p>
                                    </div>
                                    <div style={{ ...styles.flexRow, display: 'flex', justifyContent: 'space-between' }}>
                                        <p style={{ ...styles.inverseText }}>Estimated Minting Costs</p>
                                        <p style={{ ...styles.bold, ...styles.dullText }}>(10,000.00)</p>
                                    </div>
                                    {lightBorderLessPadding()}
                                    <div style={{ ...styles.flexRow, display: 'flex', justifyContent: 'space-between' }}>
                                        <p style={{ ...styles.bold, ...styles.inverseText }}>Net Proceeds </p>
                                        <p style={{ ...styles.bold, ...styles.inverseText }}> 813,398.00</p>
                                    </div>
                                </div>
                                {lightBorder(this.howToBuy)}

                                <p style={{ ...styles.inverseText, ...styles.header1, ...styles.bold, fontStyle: 'italic', ...styles.marginBottomSmall }}>HOW TO BUY?</p>
                                <p style={{ ...styles.inverseText, ...styles.justify }}>If you do not have any wallet yet, please install MetaMask's wallet <a style={{ ...styles.inverseText }} target="_blank" rel="noreferrer" href='https://metamask.io/'>here</a>, and learn how to add funds to your MetaMask wallet <a style={{ ...styles.inverseText }} target="_blank" rel="noreferrer" href='https://metamask.io/faqs/'>here</a>. Once you have a funded wallet, click on “Connect Wallet” at the top of the page. A variety of options will appear, which will direct you to the wallet connect functionality for each. After connecting your wallet, you will see the option to purchase a ticket, which you can do so at your leisure!</p>
                                {lightBorder()}

                                <p style={{ ...styles.inverseText, ...styles.header1, ...styles.bold, fontStyle: 'italic', ...styles.marginBottomSmall }}>OUR VISION</p>
                                <div style={{ ...styles.flexRow, display: 'flex' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                        <p style={{ ...styles.centerText, ...styles.inverseText, ...styles.justify }}>At Boulé, we believe in challenging conventional ideology around wealth distribution. We do this by leveraging trustless smart contracts to work in favor of the masses.</p>
                                        <p style={{ ...styles.centerText, ...styles.inverseText, ...styles.justify }}>We often hear how “fortune favors the brave”, and we want the brave to prosper. </p>
                                        <p style={{ ...styles.centerText, ...styles.inverseText, ...styles.justify }}>Based on the same fundamentals of an ancient Greek Boule, we are using Smart Contracts/lazy mint to mint 1 million tokens. After all tokens are sold, 1 token will be randomly chosen as the winning NFT. This single token, the Greek, will receive all of the net proceeds of 1 million minted tokens, estimated value 813,398 MATIC.</p>
                                    </div>
                                    {!isMobile && <img alt={'zeus'} width={250} height={250} src={zeus} style={{
                                        marginLeft: 50, borderRadius: 8, ...styles.shadow,
                                    }}></img>}
                                </div>

                                {lightBorder()}

                                <p style={{ ...styles.inverseText, ...styles.header1, ...styles.bold, fontStyle: 'italic', ...styles.marginBottomSmall }}>THE SPECS</p>
                                <p style={{ ...styles.inverseText, ...styles.justify }}>The Boule will use a lazy minting process, utilizing ERC-721 tokens (NFTs) on Polygon. The Solidity contract is trustless as to ensure the integrity of the game. After all the tokens are sold, the trustless contract will randomly choose the winning  token and all Matic will be automatically transferred to that address.</p>
                                {lightBorder()}
                                {!isMobile && <div style={{ ...styles.inverseText, ...styles.centerText, marginBottom: 30, marginTop: 50, ...styles.bold }}>SMART CONTRACT ADDRESS: <a href={`https://polygonscan.com/address/${CONTRACT_ADDRESS}#code`} target={'_blank'} rel="noreferrer" style={{ color: 'white' }}>{CONTRACT_ADDRESS}</a></div>}
                                <div style={{ display: 'flex', flexDirection: 'column', ...styles.centerAligned }}>
                                    <p style={{ ...styles.inverseText, ...styles.bold, fontStyle: 'italic', ...styles.marginBottomSmall }}>JOIN THE LIST</p>
                                    <div style={{ ...styles.flexRowSpaceBetween, display: 'flex' }}>
                                        <input onChange={(e) => this.setState({ potentialEmail: e.target.value })} className='placeholder' placeholder='Email Address' style={{ padding: 0, paddingLeft: 10, ...styles.marginBottom, backgroundColor: '#675FC8', border: '1px solid white', height: 30, width: 180, color: 'white' }}></input>
                                        <div className='clickable' onClick={(potentialEmail && potentialEmail.match(emailRegex)) ? () => this.setState({ emailOnList: potentialEmail }) : () => { }} style={{ width: 50, height: 32, backgroundColor: 'white', color: '#473FA8', ...styles.centeredContainer, display: 'flex', ...styles.header3, cursor: 'pointer' }}>➞</div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', ...styles.flexRow, alignItems: 'center', justifyContent: 'center', ...styles.marginBottom }}>
                                    <div style={{ ...styles.inverseText, ...styles.marginRight }}>©2022 by Boulé.</div>
                                    <a href={'https://discord.com/invite/URcJDsamcv'} target={'_blank'} rel="noreferrer"><img alt='discord' style={{ height: 30, ...styles.marginRight }} src={discord} /></a>
                                    <a href={'https://www.reddit.com/user/BouleNFT'} target={'_blank'} rel="noreferrer"><img alt='reddit' style={{ height: 30, filter: 'invert(1)', ...styles.marginRight }} src={reddit} /></a>
                                    <a href={'https://twitter.com/BouleNft'} target={'_blank'} rel="noreferrer"><img alt='twitter' style={{ height: 30, filter: 'invert(1)' }} src={twitter} /></a>
                                </div>
                            </div>

                        </div>
                    </div >
                }
            </Transition>
        );
    }
}

export default App;
